import { DownloadO, IconClose } from '@/assets';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

const ANIMATION_DURATION = 250; // ms

const DownloadPortfolioModal = ({ isOpen, handleClose }: ModalProps) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(isOpen);
  const [animate, setAnimate] = useState<'open' | 'close'>('open');

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      setAnimate('open');
    } else if (visible) {
      setAnimate('close');
      const timer = setTimeout(() => setVisible(false), ANIMATION_DURATION);
      return () => clearTimeout(timer);
    }
  }, [isOpen, visible]);

  if (!visible) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div className={`modal-overlay ${animate}`} onClick={handleOverlayClick}>
      <div className="modal-container">
        <div className="modal-content">
          <div className="modal-header">
            <h2 className="modal-title">
              {t('Download')}
              <br />
              {t('Portfolio')}
            </h2>
            <button className="close-button" onClick={handleClose}>
              <IconClose />
            </button>
          </div>

          <div className="divider"></div>

          <div className="download-options">
            <DownloadOption
              language={t('English Version')}
              link="https://drive.google.com/file/d/1FzEijaHiN4Yfz9wpO78YSuICQbxav-dl/view?usp=sharing"
            />
            <DownloadOption
              language={t('Korean Version')}
              link="https://drive.google.com/file/d/1070qIDqmdHdiwsNbZIakIXFeJHWJbmk6/view?usp=sharing"
            />
            <DownloadOption
              language={t('Vietnamese Version')}
              link="https://drive.google.com/file/d/13WBE7A7lCqpTJ4ESF9e4JLjY8x9eyDwF/view?usp=sharing"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

interface DownloadOptionProps {
  language: string;
  link: string;
}

const DownloadOption: React.FC<DownloadOptionProps> = ({ language, link }) => {
  const { t } = useTranslation();
  return (
    <div className="download-option">
      <span className="language">{language}</span>
      <a href={link} download target="_blank" rel="noopener noreferrer" className="download-button">
        {t('Download')}
        <DownloadO />
      </a>
    </div>
  );
};

export default DownloadPortfolioModal;
